import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatFilterBar = createCustomElementWrapper('kat-filter-bar', 'KatFilterBar', {
    'katFilterBarAction': 'KatFilterBarAction',
    'showActionApply': 'show-action-apply',
    'showActionClear': 'show-action-clear',
    'showActionFilters': 'show-action-filters',
    'showActionSearch': 'show-action-search',
    'showActionSettings': 'show-action-settings',
    'showActionSort': 'show-action-sort',
    'showFilterCreate': 'show-filter-create',
    'showFilterEdit': 'show-filter-edit',
}, {
    'onAction': 'action',
}, [
    'quick-filters',
]);
